import { css, styled } from "styled-components";

export const Preview2Wrapper = styled.div`
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;

  position: relative;
  > svg {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const Preview2Logo = styled.img`
  position: absolute;
  top: 5.89px;
  right: 4.88px;
  z-index: 1;
  width: 155.874px;
  height: 114.47px;
`;

export const Preview2Header = styled.div<{
  isHideLine: boolean;
  infoType: boolean;
}>`
  z-index: 1;
  width: calc(100% - 32.86px);
  padding: 16.43px 16.43px 11.27px;

  display: flex;
  flex-direction: column;

  position: relative;
  ${({ isHideLine, infoType }) =>
    !isHideLine &&
    css`
      outline: 3px dashed ${infoType ? "#6436E7" : "#bebebe"};
      outline-offset: -3px;
    `}
`;

export const Preview2HeaderTop = styled.div`
  width: 100%;
  height: 26.28px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6.25px;

  > img {
    width: 79.74px;
    height: 26.29px;
    object-fit: cover;
  }

  color: #b7b6bd;
  text-shadow: 0 2.191px 2.191px rgba(0, 0, 0, 0.25);
  font-family: Pretendard;
  font-size: 16.431px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;

export const Preview2HeaderBottom = styled.div`
  width: 100%;
  margin-top: 20.27px;
  display: flex;
  flex-direction: column;
`;

export const Preview2Date = styled.div<{ color: string }>`
  width: 100%;
  height: 26px;

  color: ${({ color }) => color};
  text-shadow: 0 2.191px 2.191px rgba(0, 0, 0, 0.25);
  font-family: Pretendard;
  font-size: 21.908px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;

export const Preview2SubTitle = styled.div<{ color: string }>`
  width: 100%;
  height: 26px;
  margin-top: 5.77px;

  color: ${({ color }) => color};
  text-shadow: 0 2.191px 2.191px rgba(0, 0, 0, 0.25);
  font-family: "esamanru";
  font-size: 22.908px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;

export const Preview2Title = styled.div<{ color: string }>`
  width: 100%;
  height: 32px;
  margin-top: 0.29px;

  color: ${({ color }) => color};
  text-shadow: 0 2.191px 2.191px rgba(0, 0, 0, 0.25);
  font-family: "esamanru";
  font-size: 24.385px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;

export const Preview2Body = styled.div`
  width: calc(100% - 32.86px);
  padding: 0 16.43px;
  display: flex;
  flex-direction: row;
  gap: 16.43px;
  position: relative;
`;

export const Preview2BodyLeft = styled.div<{ showAddress: boolean }>`
  width: 224.55px;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: ${({ showAddress }) => (showAddress ? "6.43px" : "16.43px")};
`;

export const Preview2InfoWrapper = styled.div<{
  isHideLine: boolean;
  infoType: boolean;
}>`
  width: 100%;
  height: 164.311px;
  display: flex;
  flex-direction: column;
  border-radius: 13.145px;
  background: rgba(0, 0, 0, 0);
  border: 0.548px solid rgb(61, 61, 61);
  ${({ isHideLine, infoType }) =>
    !isHideLine &&
    css`
      outline: 3px dashed ${infoType ? "#6436E7" : "#bebebe"};
      outline-offset: -3px;
    `}

  box-shadow: 0 2.191px 2.191px 0 rgba(0, 0, 0, 0.25);
`;

export const Preview2InfoTitle = styled.div`
  width: calc(100% - 32.862px);
  height: calc(27.38px - 10.954px);
  padding: 5.477px 16.431px;
  border-radius: 13.145px 13.145px 0 0;
  background: rgba(255, 255, 255, 0.17);
  display: flex;
  flex-direction: row;
  align-items: center;

  color: #fff;
  font-family: "esamanru";
  font-size: 16.431px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;
export const Preview2InfoContent = styled.div<{ fontSize: string }>`
  width: 100%;
  flex: 1;
  margin-top: 5.48px;
  display: flex;
  flex-direction: column;
  gap: 2.6px;
  font-size: ${({ fontSize }) => fontSize}px;
`;

export const Preview2InfoContentItem = styled.div<{ isShow: boolean }>`
  width: calc(100% - 32.862px);
  height: 10px;
  padding: 0 16.431px;
  display: ${({ isShow }) => (isShow ? "flex" : "none")};
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  color: #fff;
  font-family: "esamanru";
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;

export const Preview2NoticeWrapper = styled.div<{
  isHideLine: boolean;
  infoType: boolean;
}>`
  width: 100%;
  height: 197.173px;
  display: flex;
  flex-direction: column;
  border-radius: 13.145px;
  background: rgba(0, 0, 0, 0.3);
  box-shadow: 0 2.191px 2.191px 0 rgba(0, 0, 0, 0.25);
  border: 0.548px solid rgb(61, 61, 61);
  ${({ isHideLine, infoType }) =>
    !isHideLine &&
    css`
      outline: 3px dashed ${infoType ? "#6436E7" : "#bebebe"};
      outline-offset: -3px;
    `}
`;

export const Preview2NoticeTitle = styled.div`
  width: calc(100% - 32.862px);
  height: calc(27.38px - 10.954px);
  padding: 5.477px 16.431px;
  border-radius: 13.145px 13.145px 0 0;
  background: rgba(255, 255, 255, 0.17);
  display: flex;
  flex-direction: row;
  align-items: center;

  color: #fff;
  font-family: "esamanru";
  font-size: 16.431px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;
export const Preview2NoticeContent = styled.div`
  width: calc(100% - 32.862px);
  flex: 1;
  padding: 5.477px 16.431px;
  color: #fff;
  font-family: "esamanru";
  font-size: 9.859px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;

  white-space: pre-line;

  p {
    margin: 0;
    padding: 0;
    margin-block-start: 0;
    margin-block-end: 0;
    margin-block-start: 0;
  }
`;

export const Preview2PrizePoolWrapper = styled.div<{
  isHideLine: boolean;
  infoType: boolean;
}>`
  width: 100%;
  height: 299.237px;
  display: flex;
  flex-direction: column;
  border-radius: 13.145px;
  background: rgba(0, 0, 0, 0);
  border: 0.548px solid rgb(61, 61, 61);
  ${({ isHideLine, infoType }) =>
    !isHideLine &&
    css`
      outline: 3px dashed ${infoType ? "#6436E7" : "#bebebe"};
      outline-offset: -3px;
    `}
`;

export const Preview2PrizePoolBox = styled.div`
  width: calc(100% - 32.862px);
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 5.477px 16.43px;
  gap: 1.1px;

  background: rgba(0, 0, 0, 0);

  border-radius: 0 0 13.145px 13.145px;
`;

export const Preview2PrizePoolItem = styled.div<{ fontSize: number }>`
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  color: #fff;
  text-align: center;
  font-family: Pretendard;
  font-size: ${({ fontSize }) => fontSize}px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;

export const Preview2BodyRight = styled.div<{
  isHideLine: boolean;
  infoType: boolean;
  showAddress: boolean;
}>`
  flex: 1;
  height: calc(100% - 2px);
  display: flex;
  flex-direction: column;

  border-radius: 13.145px;
  background: rgba(0, 0, 0, 0);
  box-shadow: 0 2.191px 2.191px 0 rgba(0, 0, 0, 0.1);
  border: 0.548px solid rgb(61, 61, 61);
  ${({ isHideLine, infoType }) =>
    !isHideLine &&
    css`
      outline: 3px dashed ${infoType ? "#6436E7" : "#bebebe"};
      outline-offset: -3px;
    `}
`;

export const Preview2StructureTitle = styled.div`
  width: calc(100% - 32.86px);
  padding: 4.19px 16.43px;
  display: flex;
  align-items: center;
  color: #fff;
  font-family: "esamanru";
  font-size: 16.431px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;

  border-radius: 13.145px 13.145px 0 0;

  background: rgba(255, 255, 255, 0.1);
`;

export const Preview2structureHeaderWrapper = styled.div`
  width: calc(100% - 32.86px);
  height: 21.9px;
  padding: 0px 16.43px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12.62px;
  background: rgba(255, 255, 255, 0.1);
`;

export const Preview2structureHeaderItem = styled.div<{
  flex: number;
  isShow: boolean;
}>`
  flex: ${({ flex }) => flex};
  ${({ isShow }) =>
    !isShow &&
    css`
      display: none;
    `}
  color: #FFF;
  text-align: center;
  font-family: "esamanru";
  font-size: 7.668px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;

export const Preview2StructureRow = styled.div<{
  hasLine: boolean;
  isFinal: boolean;
}>`
  width: calc(100% - 32.86px);
  flex: 1;
  padding: 0px 16.43px;
  display: flex;
  flex-direction: row;
  gap: 12.62px;
  align-items: center;
  background: rgba(0, 0, 0, 0.35);

  ${({ isFinal }) =>
    isFinal &&
    css`
      border-radius: 0 0 8.763px 8.763px;
    `}

  ${({ hasLine }) =>
    hasLine &&
    css`
      border-top: 0.548px solid rgb(61, 61, 61);
    `}
`;
export const Preview2StructureItem = styled.div<{
  flex: number;
  isShow: boolean;
}>`
  flex: ${({ flex }) => flex};
  ${({ isShow }) =>
    !isShow &&
    css`
      display: none;
    `}

  color: #FFF;
  text-align: center;
  font-family: "esamanru";
  font-size: 7.668px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;

export const Preview2StructureBreak = styled.div`
  width: calc(100% - 32.86px);
  flex: 1;
  padding: 0px 16.43px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
  text-align: center;
  font-family: "esamanru";
  font-size: 7.668px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;

export const Preview2AddressWrapper = styled.div`
  position: absolute;
  bottom: 10.43px;
  left: 0;
  width: calc(100% - 32.86px);
  flex: 1;
  padding: 0px 16.43px;
  display: flex;
  flex-direction: column;

  align-items: center;
  color: #fff;
  text-align: center;
  font-family: Pretendard;
  font-size: 10.954px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;

export const Preview2ImageWrapper = styled.div<{
  topPadding: number;
  rightPadding: number;
}>`
  position: absolute;
  top: ${({ topPadding }) => topPadding}px;
  right: ${({ rightPadding }) => rightPadding}px;
  height: ${({ topPadding }) =>
    topPadding ? `${164 - topPadding}px` : `165px`};
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  z-index: 1;
  > img {
    height: 100%;
    object-fit: cover;
  }
`;
